const CPIConstants = {
  /*
   * Used to calculate the eligible amount based on cost of improvement and number of units.
   * <improvement cost amount> / 120 / <count of units>
   */
  eligibleAmountDivider: 120,
};

export default CPIConstants;
